import React from "react";
import { Link } from "react-router-dom";

/**
 * Reusable Plaintr Logo component
 * @param {Object} props - Component props
 * @param {string} props.to - Link destination (default: "/")
 * @param {number} props.height - Logo height in pixels (default: 50)
 * @param {Object} props.style - Additional styles to apply
 * @param {boolean} props.clickable - Whether the logo should be clickable (default: true)
 * @param {string} props.className - Additional CSS classes
 */
function Logo({
  to = "/",
  height = 50,
  style = {},
  clickable = true,
  className = "",
}) {
  const logoElement = (
    <img
      src={`${process.env.PUBLIC_URL}/images/logo_dark_blue.svg`}
      alt="Plaintr Logo"
      height={height}
      style={{
        borderRadius: 0,
        marginBottom: 20,
        ...style,
      }}
      className={className}
    />
  );

  if (clickable) {
    return <Link to={to}>{logoElement}</Link>;
  }

  return logoElement;
}

export default Logo;
